import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#1976d2',
        },
        secondary: {
            main: '#ff5722',
        },
    },

    typography: {
        fontFamily: 'Arial, sans-serif',
    },

    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#888 #f1f1f1',
                },
            },
        },

        MuiTextField: {
            styleOverrides: {
                root: {
                    // borderRadius: '16px',
                    width: '100%',
                },
            },
        },

        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    // borderRadius: '4px',
                    height: '32px', // ✅ reduced height
                    fontSize: '12px',
                    fontFamily: 'Arial, sans-serif',
                    display: 'flex',
                    alignItems: 'center',
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#1976d2',
                    },

                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        borderColor: '#628dd1',
                        borderWidth: '2px',
                    },
                },
                input: {
                    padding: '6px 8px',
                    fontFamily: 'Arial, sans-serif',
                },
                notchedOutline: {
                    borderColor: '#ccc',
                },
            },
        },

        MuiInputLabel: {
            styleOverrides: {
                root: {
                    color: '#555',
                    fontFamily: 'Arial, sans-serif',
                    transform: 'translate(10px, 6px) scale(1)',
                    '&.Mui-focused': {
                        color: '#ff5722',
                    },
                },

                shrink: {
                    transform: 'translate(12px, -6px) scale(0.65)',
                },
            },
        },

        MuiSelect: {
            styleOverrides: {
                select: {
                    padding: '2px 4px',
                    display: 'flex',
                    alignItems: 'center',
                },
            },

            defaultProps: {
                MenuProps: {
                    PaperProps: {
                        sx: {
                            fontFamily: 'Arial, sans-serif',
                            boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
                        },
                    },
                    sx: {
                        width: '100vw',
                    },
                },
            },
        },

        MuiMenu: {
            styleOverrides: {
                paper: {
                    fontFamily: 'Arial, sans-serif',
                    boxShadow: '0px 8px 24px rgba(0,0,0,0.15)',
                },
            },
        },
        MenuItem: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    fontFamily: 'Arial, sans-serif',
                    padding: '1px',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    fontFamily: 'Arial, sans-serif',
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                root: {
                    padding: '6px 10px',
                    fontSize: '12px',
                    lineHeight: '1.2',
                    fontFamily: 'Arial, sans-serif',
                    margin:"2rem",
                    whiteSpace: "normal",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                },
                head: {
                    padding: '6px 10px',
                },
                
            },
        },
    },
});

export default theme;